// utils/resizeImage.js
export async function resizeImage(
  file,
  {
    maxSize = 512,        // avatar size (px)
    quality = 0.8,        // jpeg/webp quality
    mimeType = "image/jpeg",
  } = {}
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      let { width, height } = img;

      if (width > height && width > maxSize) {
        height = Math.round((height * maxSize) / width);
        width = maxSize;
      } else if (height > maxSize) {
        width = Math.round((width * maxSize) / height);
        height = maxSize;
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          URL.revokeObjectURL(url);
          if (!blob) return reject("Image resize failed");

          resolve(
            new File([blob], file.name, {
              type: mimeType,
              lastModified: Date.now(),
            })
          );
        },
        mimeType,
        quality
      );
    };

    img.onerror = reject;
    img.src = url;
  });
}
